<a class="logo"
   [routerLink]="'/'">
  <svg>
    <use [attr.xlink:href]="'assets/icons.svg#logo'"
         [attr.href]="'assets/icons.svg#logo'">
    </use>
  </svg>
</a>
